import type { InfluenceGraphModel } from './model';
export interface PositionedNode { id: string; x: number; y: number; }
export interface PositionedRelationship { id: string; source: PositionedNode; target: PositionedNode; }
const positions: Record<string, [number, number]> = {
  josh: [85, 240], ken: [255, 240], james: [430, 170], sarah: [610, 170], bbc: [795, 170],
  david: [430, 55], cnbc: [610, 55], marcus: [430, 285], planet: [610, 285], fiona: [430, 395], ft: [610, 395], aaron: [610, 505], cna: [795, 505],
};
export function createGraphViewModel(model: InfluenceGraphModel) {
  const nodes = model.nodes.map((node, index) => { const [x, y] = positions[node.id] ?? [85 + (index % 5) * 175, 55 + Math.floor(index / 5) * 115]; return { id: node.id, x, y }; });
  const byId = new Map(nodes.map((node) => [node.id, node]));
  const relationships = model.relationships.flatMap((relationship) => { const source = byId.get(relationship.sourceId); const target = byId.get(relationship.targetId); return source && target ? [{ id: relationship.id, source, target }] : []; });
  return { nodes, relationships };
}
